<template>
	<div class="sub-total">
		<div class="sub-total-details">
			<div class="sub-total-number">
				<h1>
					Subtotal:
				</h1>
				<promo-sales-timed>
					<template v-slot:originalContent>
						<span>{{ totalCartPrice | formatMoney }}</span>
					</template>
					<template>
						<span>
							{{ promoDiscount(totalCartPrice) | formatMoney }}
						</span>
					</template>
				</promo-sales-timed>
				<span class="currency-code">USD</span>
			</div>
			<p> {{ shippingInfo | stripTags }}</p>
			<!-- <promo-sales-timed>
				<template v-slot:originalContent>
					<p> {{ shippingInfo | stripTags }}</p>
				</template>
				<template slot-scope="{ phasesInfo: { currentPhase } }">
					<promo-savings-msg
						v-if="currentPhase == 1"
						:phase="currentPhase"
						text="accessories_cart"
						:price="totalCartPrice"
						:shipping="shippingInfo | stripTags"
					/>
					<template v-if="currentPhase == 2">
						<promo-savings-msg
							v-if="buildHasElegiblePrice"
							:phase="currentPhase"
							text="accessories_cart_2"
							:shipping="shippingInfo | stripTags"
						/>
						<promo-savings-msg
							v-else
							:phase="currentPhase"
							text="accessories_cart_1"
							:price="totalCartPrice"
						/>
					</template>
				</template>
			</promo-sales-timed> -->
		</div>
		<div class="sub-total-action">
			<button
				v-if="isInStock"
				type="button"
				class="btn continue-to-cart text-uppercase"
				:class="buttonClass"
				@click="goToCart"
			>
				<slot />
			</button>
			<button
				v-else
				type="button"
				class="btn continue-to-cart btn-soldout"
				:class="buttonClass"
			>
				SOLD OUT
			</button>
		</div>
	</div>
</template>

<script>
// import PromoSavingsMsg from "@c/generals/promo-savings-msg";
import PromoSalesTimed from "@/components/promo-sales-timed";
import { promoDiscount } from "@u/helpers";

export default {
	name: "Subtotal",
	components: {
		// PromoSavingsMsg,
		PromoSalesTimed
	},
	props: {
		buttonClass: {
			type: [String, Object],
			default: ""
		},
		totalCartPrice: {
			type: [String, Number],
			default: 0
		},
		shippingInfo: {
			type: String,
			default: ""
		},
		isInStock: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		buildHasElegiblePrice() {
			return !Number.isNaN(Number(this.totalCartPrice)) && Number(this.totalCartPrice) >= 1000;
		}
	},
	methods: {
		promoDiscount,
		goToCart() {
			this.$emit("go-to-cart");
		}
	}
};
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.sub-total::v-deep {
	.promo-savings-msg {
		font-size: 16px;
		margin-bottom: 0;
		text-align: right;

		p {
			font-size: 14px;
			line-height: 19px !important;
			color: #5f707f !important;
		}
	}

	@media (min-width: 320px) and (max-width: 480px) {
		.promo-savings-msg {
			text-align: left;
		}
	}
}


.sub-total {
	max-width: 610px;
	display: flex;

	@media (min-width: 1200px) {
		align-items: center;
	}

	.disable-element {
		opacity: 0.5;
	}

	@media (max-width: 768px) {
		flex-direction: column;
	}

	@media (min-width: 320px) and (max-width: 580px) {
		width: 100%;
		margin-left: 0;
		margin-right: 0;
		align-items: flex-start;
	}

	&-details {
		display: flex;
		flex-direction: column;

		@media (max-width: 580px) {
			margin: 22px 0;
		}

		.sub-total-number {
			display: flex;
			align-items: center;
			justify-content: flex-end;

			.currency-code {
				align-self: flex-end;
				font-size: 14px;
				font-weight: 200;
				margin-bottom: -4px;
				margin-left: 2px;

				@media (min-width: 320px) and (max-width: 580px) {
					margin-bottom: -2px;
				}

				@media only screen
				and (min-device-width : 768px)
				and (max-device-width : 1024px)
				and (orientation : portrait) {
					align-self: auto;
				}

			}

			@media (max-width: 768px) {
				justify-content: flex-start;
			}

			h1 {
				color: #5f707f;
				margin-top: 0;
				margin-bottom: 0;
				font-size: 32px;
				line-height: 38px;

				@media (max-width: 991px) {
					font-size: 20px;
					line-height: 24px;
				}
			}

			span {
				color: #51007a;
				font-size: 32px;
				line-height: 38px;
				margin-left: 8px;

				@media (max-width: 768px) {
					font-size: 20px;
					line-height: 24px;
					margin-left: 5px;
				}
			}
		}

		p {
			color: #5f707f;
			font-size: 16px;
			line-height: 19px;
			margin-bottom: 0;
			text-align: right;

			@media (max-width: 768px) {
				text-align: left;
				font-size: 14px;
				line-height: 18px;
			}
		}
	}

	.continue-to-cart {
		background: $purple;
		border-color: $purple;
		color: $white;
		margin-left: 20px;

		&:hover {
			background: transparent;
			color: $purple;
		}

		@media (max-width: 768px) {
			margin-left: 0;
			width: 100%;
		}
	}

	&-action {
		display: flex;
		width: auto;
		@media (min-width: 320px) and (max-width: 580px) {
			width: 100%;
		}

		.btn-soldout {
			background-color: rgba(#5F707F, 0.3);
			border: none;
			color: $white;
			pointer-events: none;
		}
	}
}
</style>
